module.exports = __webpack_public_path__ + "assets/img/29_227_big.83a77605.jpg";